import { COLORS } from 'Components/utils/color/colors';

export const themes = {
  default: ({ color = COLORS.BLUE }) => ({
    thIconWidth: '.7em',
    thRoot: `text-${color} font-bold font-sans leading-normal text-base focus:underline hover:underline`,
    thLabel: '',
    thIconLeft: 'rtl:mr-2',
    thIconRight: 'rtl:ml-2',
  }),
  fancy: ({ color = COLORS.WHITE }) => ({
    thIconWidth: '0.4375rem',
    thRoot: `text-${color} font-bold font-sans leading-normal text-sm`,
    thLabel: '',
    thIconLeft: 'rtl:mr-2',
    thIconRight: 'rtl:ml-2',
  }),
  solid: ({ color = COLORS.BLUE }) => ({
    thIconWidth: '1em',
    thRoot: `text-${color} bg-current font-bold font-sans leading-one p-3 rounded-tiny text-base uppercase`,
    thLabel: 'text-white',
    thIconLeft: 'text-white rtl:mr-2',
    thIconRight: 'text-white rtl:ml-2',
  }),
  simple: ({ color = COLORS.GRAY_DARKER }) => ({
    thIconWidth: '1em',
    thRoot: `text-${color} font-sans leading-loose self-start rtl:ml-auto text-base underline`,
    thLabel: '',
    thIconLeft: 'rtl:mr-2',
    thIconRight: 'rtl:ml-2',
  }),
};
